import { render, staticRenderFns } from "./EditCatModal.vue?vue&type=template&id=6c64c6fb&"
import script from "./EditCatModal.vue?vue&type=script&lang=js&"
export * from "./EditCatModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports